export enum AgeGroups {
  Junior = 'junior',
  Adult = 'adult',
  Online = 'online',
}

export type AgeGroup = AgeGroups.Junior | AgeGroups.Adult | AgeGroups.Online;
